module.exports = __webpack_public_path__ + "img/Ai Class.be265313.png";